<template>
  <div>
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="logo">
        <img src="/logo.png" alt="zmaticoo" class="logo-img" />
        <span class="logo-line"></span>
        <span class="logo-text">{{ logoText }}</span>
      </div>
      <div class="opt-box">
        <div class="language-switcher">
          <div class="switcher-options">
            <div class="option" v-for="(item,index) in langeList" :key="index" :class="{ 'active': pageLanguage == item.lang }" @click="switchLanguage(item.lang)" >{{ item.name }}<span class="line" v-show="!index">/</span> </div>
          </div>
        </div>
        <div class="contact-btnBox" ref="contactBtn" @click.stop="toggleContactMenu">
          <img src="/customer.png" alt="" class="contact-icon" />
          <button class="contact-btn">{{ contactBtnText }}</button>
          <div ref="contactMenu" class="contact-dropdown" :class="{ show: isContactMenuShow }">
            <p class="contact-title">
              <img src="/mail.png" alt="" class="mail-icon" />
              <span ref="contactEmail">{{ contactEmailText }}</span>
            </p>
            <a href="mailto:support@zmaticoo.com" class="text-blue-600">support@zmaticoo.com</a>
          </div>
        </div>
      </div>
    </header>
     <!-- 搜索面板组件（核心：目录级搜索+结果切换+正常跳转） -->
   <sdk-document-search :showSearchPanel="showSearchPanel" :searchKeyword="searchKeyword" :searchPlaceholder="searchPlaceholder" :currentResultIndex="currentResultIndex" :searchResults="searchResults" :inputSearchKeywordText="inputSearchKeywordText" :noSearchResultText="noSearchResultText" :resultCountText="resultCountText"  :highlightKeyword="highlightKeyword" :scrollToResult="scrollToResult"
   @SearchInput="handleSearchInput"  @SearchClose="handleSearchClose"></sdk-document-search>
    <!-- 主体内容区 -->
    <main class="content">
      <layout :activeMenuId="activeMenuId" :pageLanguage="pageLanguage" :leftMenuItems="leftMenuItems" @menuChange="menuChange"></layout>
      <div class="doc-container">
        <div class="content-area">
           <!-- 搜索触发按钮 -->
        <div class="search-trigger"  @click="showSearchPanel = true">
          <span><img src="../assets/search.png" class="search-icon"></span>
          <span class="search-text">{{ searchTriggerText }}</span>
        </div>
          <div
            :class="['content-wrapper','content-wrapper_help']"
            ref="docContent"
            v-html="renderedHtmlContent"
            @click="onDocContentClick($event)"
          ></div>
        </div>
        <div class="toc-sidebar" ref="tocSidebar">
          <ul class="toc-list" ref="tocList">
            <li 
              class="toc-item" 
              v-for="item in currentTocItems" 
              :key="item.id"
            >
              <a 
                :href="`#${item.id}`"
                class="toc-link" 
                :class="[`toc-level-${item.level}`, { active: getFinalHighlightId() === item.id}]"
                :data-id="item.id"
                v-show="item.level<4"
                @click.prevent="scrollToHeading(item.id)"
              >
                {{ item.text }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </main>
    <!-- loading组件 -->
    <loading :isLoading="isLoading" :loadingText="loadingText"></loading>
    <transition name="link-copy-toast-fade">
      <div
        v-show="linkCopyToastVisible"
        class="link-copy-toast"
        role="status"
        aria-live="polite"
      >
        {{ linkCopyToastBody }}
      </div>
    </transition>
  </div>
</template>

<script>
import { marked } from 'marked'
import hljs from 'highlight.js'
// 导入 highlight.js 完整样式（确保彩色高亮基础生效），替换为更鲜艳的浅色主题
import 'highlight.js/styles/vs.min.css' 
import SdkDocumentSearch from './SdkDocumentSearch.vue';
import loading from './loading.vue'
import layout from './layout.vue'
export default {
  name: 'DocViewer',
  components: {
    loading,
    layout,
    SdkDocumentSearch
  },
  data() {
    return {
      manualClickLockTime: null, // 手动点击锁定计时器
      scrollReleaseTimer: null,
      scrollStartTime: null,
      manualActiveId: '', // 手动点击的导航ID（优先级最高）
      isScrolling: false, // 标记是否在滚动中
      isContactMenuShow: false,
      isLoading: false,
      pageLanguage: 'en',
      langeList: [
        {
          name: 'EN',
          lang:'en'
        },
        {
          name: '中文',
          lang:'zh'
        }
        
      ],
      docUrl:'',
      // 多语言文本
      logoText: "SDK Integration Guide",
      contactBtnText: "Contact Us",
      contactEmailText: "Mail",
      loadingText: "Loading",
      // 文档渲染相关
      renderedHtmlContent: "",
      currentTocItems: [],
      structure: [],
      activeTocId: "",
      // 观察者实例
      headingObserver: null,
      contentContainer: null,
      slidContainer: null,
      leftMenuItems: [
        {
          titleZh: '平台使用指南',
          titleEn:'Platform User Guide',
          children: [
            {
              nameZh: '平台使用指南',
              nameEn:'Platform User Guide',
              id: '1101',
              docUrl:'PlatformUserGuide/PlatformUserGuide'
            },
            {
              nameZh: 'App-ads.txt',
              nameEn:'App-ads.txt',
              id: '1102',
              docUrl:'PlatformUserGuide/App-ads'
            },
            {
              nameZh: '重要公告',
              nameEn:'Important Notice',
              id: '1103',
              docUrl:'PlatformUserGuide/ImportantAnnouncement'
            }
          ]
        },
        {
          titleZh: 'SDK 集成',
          titleEn:'SDK Integration',
          children: [
            {
              nameZh: 'Android 集成',
              nameEn:'Android Integration',
              id: '1201',
              docUrl:'Android/SDK'
            },
            {
              nameZh: 'iOS 集成',
              nameEn:'iOS Integration',
              id: '1202',
              docUrl:'iOS/SDK'
            },
            {
              nameZh: 'Bidding 集成',
              nameEn:'Bidding Integration',
              id: '1203',
              docUrl:'Bidding/Bidding'
            },
            {
              nameZh: '测试集成',
              nameEn:'Test integration',
              id: '1204',
              docUrl:'TestMode/TestMode'
            },
            {
              nameZh: '错误码说明',
              nameEn:'Error Codes',
              id: '1205',
              docUrl:'ErrorCode/ErrorCode'
            }
            
          ]
        },
        {
          titleZh: '第三方聚合使用',
          titleEn:'Third-party aggregation usage',
          children: [
          {
              nameZh: 'MAX',
              nameEn:'MAX',
              id: '1301',
              docUrl:'Mediation/Max'
            },
            {
              nameZh: 'Admob',
              nameEn:'Admob',
              id: '1302',
              docUrl:'Mediation/Admob'
            },
            {
              nameZh: 'TopOn',
              nameEn:'TopOn',
              id: '1303',
              docUrl:'Mediation/TopOn'
            },
            {
              nameZh: 'Levelplay',
              nameEn:'Levelplay',
              id: '1304',
              docUrl:'Mediation/ironsource'
            },
            {
              nameZh: 'TradPlus',
              nameEn:'TradPlus',
              id: '1305',
              docUrl:'Mediation/Tradplus'
            },
            
          ]
        },
        {
          titleZh: '跨平台接入',
          titleEn:'Cross-platform access',
          children: [
           {
              nameZh: 'Unity',
              nameEn:'Unity',
              id: '1401',
              docUrl:'CrossPlatform/Unity'
            },
            {
              nameZh: 'Cocos',
              nameEn:'Cocos',
              id: '1402',
              docUrl:'CrossPlatform/Cocos'
            },
            {
              nameZh: 'Flutter',
              nameEn:'Flutter',
              id: '1403',
              docUrl:'CrossPlatform/Flutter'
            }
          ]
        },
        {
          titleZh:'问题中心',
          titleEn:'Help-Center',
          children: [
            {
              nameZh: '常见问题',
              nameEn:'Frequently Asked Questions',
              id: '1501',
              docUrl:'FAQ/FAQ'
            }
          ]
        },
        {
          titleZh:'合规指南',
          titleEn:'Compliance Guidelines',
          children: [
            {
              nameZh: 'TCF Vendor 披露配置',
              nameEn:'TCF Vendor Disclosure Configuration',
              id: '1601',
              docUrl:'ComplianceGuidelines/CMPVendor'
            },
            {
              nameZh: 'SDK 数据收集与共享指南',
              nameEn:'SDK Data Collection & Sharing Guidance',
              id: '1602',
              docUrl:'ComplianceGuidelines/SDK_Data_Collection&Sharing_Guidance'
            }
          ]
        },
        {
          titleZh:'开放接口',
          titleEn:'Open API',
          children: [
            {
              nameZh: 'Report API',
              nameEn:'Report API',
              id: '1701',
              docUrl:'OpenAPI/ReportApi'
            },
            {
              nameZh: 'PID Management API',
              nameEn:'PID Management API',
              id: '1702',
              docUrl:'OpenAPI/PIDManagementApi'
            },
            {
              nameZh: 'APP List API',
              nameEn:'APP List API',
              id: '1703',
              docUrl:'OpenAPI/AppListApi'
            },
            {
              nameZh: 'Block Rule API',
              nameEn:'Block Rule API',
              id: '1704',
              docUrl:'OpenAPI/BlockRuleApi'
            },
            {
              nameZh: 'Placement List API',
              nameEn:'Placement List API',
              id: '1705',
              docUrl:'OpenAPI/PlacementListApi'
            }
            
          ]
        },
        {
          titleZh:'更新日志',
          titleEn:'Changelog',
          children: [
            {
              nameZh: 'Android',
              nameEn:'Android',
              id: '1801',
              docUrl:'Changelog/Android-Changelog'
            },
            {
              nameZh: 'iOS',
              nameEn:'iOS',
              id: '1802',
              docUrl:'Changelog/iOS-Changelog'
            }
          ]
        }
      ],
      activeMenuId: '',
       // 搜索功能（核心）
      showSearchPanel: false,
      searchKeyword: '',
      searchResults: [],
      currentResultIndex: -1,
      tocTree: [],
      searchDebounceTimer: null,
      searchDebounceTime: 300,
      searchHighlightClearTimer: null,
      linkCopyToastVisible: false,
      linkCopyToastBody: '',
      linkCopyToastIsError: false,
      linkCopyToastTimer: null,
    };
  },
  computed: {
    // 搜索多语言
    searchTriggerText() {
      return this.activeMenuId==='1501'? this.pageLanguage === 'zh' ? '搜索问题' : 'Search question': this.pageLanguage === 'zh' ? '搜索当前页面内容' : 'Search the content of the current page ';
    },
    searchPlaceholder() {
      return this.activeMenuId==='1501'? this.pageLanguage === 'zh' ? '输入关键词搜索问题...' : 'Input keywords to search for questions...':  this.pageLanguage === 'zh' ? '输入关键词搜索当前页面内容...' : 'Input keywords to search the content of the current page....';
    },
    noSearchResultText() {
      return this.pageLanguage === 'zh' ? '未找到匹配的结果' : 'No matching results found';
    },
    inputSearchKeywordText() {
      return this.pageLanguage === 'zh' ? '请输入关键词进行搜索' : 'Please enter keywords to search';
    },
    resultCountText() {
      return this.pageLanguage === 'zh' ? '个结果' : 'results';
    }
   
  },
  mounted() {
    this.activeMenuId = this.$route.params.menuId || '1101';
    this.docUrl = this.findDocUrlById(this.leftMenuItems, this.activeMenuId) || 'PlatformUserGuide/PlatformUserGuide'
    this.pageLanguage = this.$route.params.language || 'en';
    this.contentContainer = this.$refs.docContent;
    this.slidContainer = this.$refs.tocSidebar
    // 初始化marked配置
    this.initMarkedOptions();
    // 初始化窗口点击监听（关闭菜单）
    this.initWindowClickListener();
    // 同窗口粘贴链接回车：hash/路由变化兜底处理
    window.addEventListener("hashchange", this.handleHashChange, false);
    this.fetchDocContent()
    this.updateLangText()
   
  },
  beforeDestroy() {
    // 销毁观察者，防止内存泄漏
    if (this.headingObserver) {
      this.headingObserver.disconnect();
    }
     clearTimeout(this.scrollReleaseTimer);
    this.scrollReleaseTimer = null;
    this.scrollStartTime = null;
    // 移除窗口点击监听
    window.removeEventListener('click', this.handleWindowClick);
    window.removeEventListener("hashchange", this.handleHashChange, false);
    // 清除滚动监听
    if (this.contentContainer) {
      this.contentContainer.removeEventListener('scroll', this.syncActiveTocOnScroll);
    }
    if (this.linkCopyToastTimer) {
      clearTimeout(this.linkCopyToastTimer);
      this.linkCopyToastTimer = null;
    }
    if (this.searchHighlightClearTimer) {
      clearTimeout(this.searchHighlightClearTimer);
      this.searchHighlightClearTimer = null;
    }
  },
  methods: {
    handleHashChange() {
      // 新链接：#/help/... ?h=xxx → 由路由 watch 触发；这里兜底做一次定位
      // 旧链接：#<route>#<heading> → vue-router 可能不会触发，需要手动 replace 到 route
      const legacy = this.parseLegacyDoubleHash(window.location.hash);
      if (legacy && legacy.routePath) {
        const current = String(this.$route.fullPath || "").split("#")[0];
        if (legacy.routePath !== current) {
          this.$router
            .replace(legacy.routePath)
            .catch(() => {})
            .finally(() => this.initHashAnchor());
          return;
        }
      }
      this.initHashAnchor();
    },
    parseLegacyDoubleHash(fullHash) {
      const h = String(fullHash || "");
      // 形如：#/<routePath>?a=b#<headingId>
      const parts = h.split("#").filter(Boolean);
      if (parts.length < 2) return null;
      const anchorId = parts[parts.length - 1] || null;
      const routePart = parts.slice(0, parts.length - 1).join("#");
      const routePath = `/${routePart}`.replace(/^\/\//, "/");
      return { routePath, anchorId };
    },
    getHeadingIdFromUrl() {
      const q = (this.$route && this.$route.query) || {};
      if (q.h) return String(q.h);
      const legacy = this.parseLegacyDoubleHash(window.location.hash);
      return legacy && legacy.anchorId ? String(legacy.anchorId) : null;
    },
    /** h 参数可能是 heading3，也可能是正文里写的标题文案（含中文）；按 id 或标题文案解析为真实标题节点 */
    resolveHeadingElement(anchorRaw) {
      if (anchorRaw == null || anchorRaw === "") return null;
      const raw = String(anchorRaw).trim();
      let decoded = raw;
      try {
        decoded = decodeURIComponent(raw);
      } catch (e) {
        decoded = raw;
      }

      const tryId = (id) => {
        if (!id) return null;
        return document.getElementById(id);
      };

      let el = tryId(raw) || tryId(decoded);
      if (el) return el;

      const root = this.$refs.docContent;
      if (!root) return null;

      const headings = root.querySelectorAll(
        "h1.section, h2.section, h3.section, h4.section, h5.section, h6.section"
      );
      const headingVisibleText = (h) => {
        const body = h.querySelector(".doc-heading-body");
        if (body) return (body.textContent || "").trim();
        const anchor = h.querySelector(".doc-heading-anchor");
        let t = h.textContent || "";
        if (anchor) t = t.replace(anchor.textContent || "", "");
        return t.trim();
      };

      const candidates = [decoded, raw].filter(Boolean);
      for (const h of headings) {
        const text = headingVisibleText(h);
        for (const c of candidates) {
          if (text === c) return h;
        }
      }
      return null;
    },
    waitForDocImages() {
      const root = this.$refs.docContent;
      if (!root) return Promise.resolve();
      const imgs = Array.from(root.querySelectorAll("img"));
      if (imgs.length === 0) return Promise.resolve();
      const pending = imgs
        .filter((img) => !img.complete)
        .map(
          (img) =>
            new Promise((resolve) => {
              const done = () => resolve();
              img.addEventListener("load", done, { once: true });
              img.addEventListener("error", done, { once: true });
            })
        );
      return Promise.all(pending).then(() => undefined);
    },
    syncDocFromRoute() {
      const nextMenuId = (this.$route.params && this.$route.params.menuId) || "1101";
      const nextLang = (this.$route.params && this.$route.params.language) || "en";
      const nextDocUrl =
        this.findDocUrlById(this.leftMenuItems, nextMenuId) || "PlatformUserGuide/PlatformUserGuide";

      const docChanged =
        String(nextMenuId) !== String(this.activeMenuId) ||
        String(nextLang) !== String(this.pageLanguage) ||
        String(nextDocUrl) !== String(this.docUrl);

      this.activeMenuId = String(nextMenuId);
      this.pageLanguage = String(nextLang);
      this.docUrl = String(nextDocUrl);
      this.updateLangText();

      if (docChanged) {
        this.fetchDocContent();
      } else {
        this.initHashAnchor();
      }
    },
    // 初始化marked配置
    initMarkedOptions() {
      marked.setOptions({
        highlight: function (code, lang) {
          return code;
        },
        langPrefix: "language-", // 代码块clss前缀
        breaks: true, // 是否解析换行符为<br>	
        gfm: true, // 是否开启GitHub 风格的 Markdown	
        pedantic: false, //是否严格遵循Markdown原始规范	
        tables: true, //是否支持Markdown表格语法	
        sanitize: false, //是否自动过滤HTML标签	
        smartLists: true, //是否优化列表解析	
        smartypants: true, //是否优化标点符号
      });
    },
    // 点击联系我们
    toggleContactMenu() {
      this.isContactMenuShow = !this.isContactMenuShow;
    },
    //更新多语言展示文本
    updateLangText() {
      if (this.pageLanguage === "zh") {
        this.logoText = "SDK对接文档";
        this.contactBtnText = "联系我们";
        this.contactEmailText = "邮箱";
        this.loadingText = "加载中";
      } else {
        this.logoText = "SDK Integration Guide";
        this.contactBtnText = "Contact Us";
        this.contactEmailText = "Mail";
        this.loadingText = "Loading";
      }
    },
    /** 断网/请求失败时的空状态 HTML（随 pageLanguage 切换） */
    getNetworkErrorRenderedHtml() {
      const zh = this.pageLanguage === "zh";
      const text = zh
        ? "无法加载文档，请检查网络后重试。"
        : "Unable to load the document. Check your network and try again.";
      const btn = zh ? "刷新页面" : "Refresh";
      return `<div class="empty-state"><img src="/404.png" class="empty-img" alt="" /><p class="empty-text">${text}</p><button type="button" class="empty-btn" onclick="window.location.reload()">${btn}</button></div>`;
    },

    //从接口获取Markdown文档内容
    fetchDocContent() {
      // 任意文档切换（含通过正文内链进入）都先回到顶部，避免沿用上一页的 scrollTop
      const container = this.contentContainer;
      const slidCon = this.slidContainer;
      if (container) {
        container.scrollTo({ top: 0, behavior: "auto" });
      }
      if (slidCon) {
        slidCon.scrollTo({ top: 0, behavior: "auto" });
      }
      this.isLoading = true;
      const url = `/api/sdk-doc-new/${this.docUrl}-${this.pageLanguage}.md`;      
      fetch(url, {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Cache-Control": "no-cache",
        },
      })
        .then((response) => {
          this.isLoading = false;
          if (response.status === 200) {
            return response.text();
          } else {
            this.renderedHtmlContent = this.getNetworkErrorRenderedHtml();
            throw new Error("Network response was not ok");
          }
        })
        .then((markdownContent) => {
          if (markdownContent) {
            this.renderMarkdown(markdownContent);
            this.initHashAnchor()
          }
        })
        .catch((err) => {
          this.renderedHtmlContent = this.getNetworkErrorRenderedHtml();
          this.isLoading = false;
          console.error(err);
        });
    },

    //解析并渲染Markdown内容
    renderMarkdown(markdownContent) {
      // 解析Markdown为HTML
      const htmlContent = marked.parse(markdownContent);
      this.renderedHtmlContent = htmlContent;
      // 等待Vue更新DOM后，处理代码块和标题
      this.$nextTick(() => {
        this.processCodeBlocks();
        this.processHeadings();
        this.initHeadingObserver();
        const container = this.contentContainer;
        if (container) {
          container.addEventListener('scroll', this.syncActiveTocOnScroll);
        }
      });
    },
    fenceLangTabSlot(lang) {
      if (!lang) return null;
      const l = String(lang).toLowerCase();
      if (l === "swift") return "swift";
      if (
        l === "objective-c" ||
        l === "objc" ||
        l === "objectivec" ||
        l === "objective_c" ||
        l === "c"
      )
        return "objective-c";
      return null;
    },
    normalizeHljsLanguageId(lang) {
      const l = String(lang || "").toLowerCase();
      if (!l) return null;
      // highlight.js 语言 id：Objective-C 为 objectivec（不是 objective-c）
      if (l === "objective-c" || l === "objective_c" || l === "objc") return "objectivec";
      return l;
    },
    getLanguageDisplayName(lang) {
      const l = String(lang || "").toLowerCase();
      if (!l) return "";
      if (l === "objectivec" || l === "objective-c" || l === "objc" || l === "objective_c") {
        return "Objective-C";
      }
      if (l === "swift") return "Swift";
      return String(lang);
    },
    isSwiftObjcConsecutivePair(lang1, lang2) {
      const a = this.fenceLangTabSlot(lang1);
      const b = this.fenceLangTabSlot(lang2);
      return !!(a && b && a !== b);
    },
    /** 同一段里用 //Swift 与 //Object-C / Objective-C 对照示例 → 整块展示，不合并 Tab */
    hasDualLangTutorialCommentsInSource(src) {
      if (!src || !String(src).trim()) return false;
      const s = String(src);
      const swiftMark = /\/\/\s*Swift\b/i.test(s);
      const objcMark =
        /\/\/\s*Objective-?C\b/i.test(s) ||
        /\/\/\s*Object-?C\b/i.test(s) ||
        /\/\/\s*ObjC\b/i.test(s);
      return swiftMark && objcMark;
    },
    shouldMergeAsSwiftObjcTabs(codeEl1, codeEl2) {
      if (!codeEl1 || !codeEl2) return false;
      const t1 = codeEl1.textContent || "";
      const t2 = codeEl2.textContent || "";
      if (this.hasDualLangTutorialCommentsInSource(t1)) return false;
      if (this.hasDualLangTutorialCommentsInSource(t2)) return false;
      return true;
    },
    buildCodeContentArea(originalCode, language, sourceCodeElement) {
      const codeContent = document.createElement("div");
      codeContent.className = "code-content";
      const codeTable = document.createElement("table");
      codeTable.className = "code-table";
      const lines = originalCode
        .split("\n")
        .filter((line, index, arr) => !(index === arr.length - 1 && line === ""));
      const codeClass =
        (sourceCodeElement && sourceCodeElement.className) ||
        (language ? `language-${this.normalizeHljsLanguageId(language)}` : "");
      lines.forEach((line, index) => {
        const tableRow = document.createElement("tr");
        const lineNumberCell = document.createElement("td");
        lineNumberCell.className = "line-numbers";
        lineNumberCell.textContent = (index + 1).toString();
        const codeCell = document.createElement("td");
        codeCell.className = "code-text";
        const codeElement = document.createElement("code");
        // highlight.js 的主题样式大多挂在 .hljs 上；必须加上，否则看起来“没高亮”
        codeElement.className = `hljs ${codeClass}`.trim();
        const hlLang = this.normalizeHljsLanguageId(language);
        if (hlLang && hljs.getLanguage(hlLang)) {
          try {
            const highlighted = hljs.highlight(line, { language: hlLang });
            codeElement.innerHTML = highlighted.value;
          } catch (err) {
            codeElement.textContent = line;
          }
        } else {
          codeElement.textContent = line;
        }
        codeCell.appendChild(codeElement);
        tableRow.appendChild(lineNumberCell);
        tableRow.appendChild(codeCell);
        codeTable.appendChild(tableRow);
      });
      codeContent.appendChild(codeTable);
      return codeContent;
    },
    replacePreWithSingleCodeBlock(preElement) {
      const codeBlock = preElement.querySelector("code");
      if (!codeBlock) return;
      const language = this.getCodeLanguage(codeBlock);
      const originalCode = codeBlock.textContent;
      const codeContainer = document.createElement("div");
      codeContainer.className = "code-block";
      const codeHeader = document.createElement("div");
      codeHeader.className = "code-header";
      const languageSpan = document.createElement("span");
      languageSpan.className = "code-language";
      languageSpan.textContent =
        this.getLanguageDisplayName(language) ||
        (this.pageLanguage === "zh" ? "代码" : "code");
      const copyButton = document.createElement("button");
      copyButton.className = "copy-btn";
      copyButton.innerHTML =
        this.pageLanguage === "zh"
          ? '<i class="far fa-copy"></i> 复制'
          : '<i class="far fa-copy"></i> Copy';
      copyButton.onclick = () => this.copyToClipboard(originalCode, copyButton);
      codeHeader.appendChild(languageSpan);
      codeHeader.appendChild(copyButton);
      const codeContent = this.buildCodeContentArea(
        originalCode,
        language,
        codeBlock
      );
      codeContainer.appendChild(codeHeader);
      codeContainer.appendChild(codeContent);
      preElement.parentNode.replaceChild(codeContainer, preElement);
    },
    buildTabbedSwiftObjcBlock(pre1, pre2, lang1, lang2) {
      const c1 = pre1.querySelector("code");
      const c2 = pre2.querySelector("code");
      const t1 = this.fenceLangTabSlot(lang1);
      const swiftCodeEl = t1 === "swift" ? c1 : c2;
      const objcCodeEl = t1 === "swift" ? c2 : c1;
      const swiftCode = swiftCodeEl.textContent;
      const objcCode = objcCodeEl.textContent;
      const swiftHl = this.getCodeLanguage(swiftCodeEl);
      let objcHl = this.getCodeLanguage(objcCodeEl);
      if (
        objcHl === "c" &&
        hljs.getLanguage &&
        hljs.getLanguage("objectivec")
      ) {
        objcHl = "objectivec";
      }

      const codeContainer = document.createElement("div");
      codeContainer.className = "code-block code-block-tabs";
      codeContainer.dataset.searchObjectiveC =
        this.normalizeSearchMatchText(objcCode);
      codeContainer.dataset.searchSwift = this.normalizeSearchMatchText(swiftCode);

      const codeHeader = document.createElement("div");
      codeHeader.className = "code-header code-header--tabs";

      const tabBar = document.createElement("div");
      tabBar.className = "code-tabs-bar";
      tabBar.setAttribute("role", "tablist");

      const mkTab = (label, tabId, isActive) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = isActive ? "code-tab is-active" : "code-tab";
        btn.setAttribute("role", "tab");
        btn.setAttribute("aria-selected", isActive ? "true" : "false");
        btn.dataset.tab = tabId;
        btn.textContent = label;
        return btn;
      };

      tabBar.appendChild(mkTab("Objective-C", "objective-c", true));
      tabBar.appendChild(mkTab("Swift", "swift", false));

      const copyButton = document.createElement("button");
      copyButton.className = "copy-btn";
      copyButton.innerHTML =
        this.pageLanguage === "zh"
          ? '<i class="far fa-copy"></i> 复制'
          : '<i class="far fa-copy"></i> Copy';
      copyButton.onclick = () => {
        const active = codeContainer.querySelector(".code-tab-panel.is-active");
        const raw =
          active && active.dataset.tab === "swift" ? swiftCode : objcCode;
        this.copyToClipboard(raw, copyButton);
      };

      codeHeader.appendChild(tabBar);
      codeHeader.appendChild(copyButton);

      const panelsWrap = document.createElement("div");
      panelsWrap.className = "code-tab-panels";

      const objcPanel = document.createElement("div");
      objcPanel.className = "code-tab-panel is-active";
      objcPanel.setAttribute("role", "tabpanel");
      objcPanel.dataset.tab = "objective-c";
      objcPanel.appendChild(
        this.buildCodeContentArea(objcCode, objcHl, objcCodeEl)
      );

      const swiftPanel = document.createElement("div");
      swiftPanel.className = "code-tab-panel";
      swiftPanel.setAttribute("role", "tabpanel");
      swiftPanel.dataset.tab = "swift";
      swiftPanel.appendChild(
        this.buildCodeContentArea(swiftCode, swiftHl, swiftCodeEl)
      );

      panelsWrap.appendChild(objcPanel);
      panelsWrap.appendChild(swiftPanel);

      codeContainer.appendChild(codeHeader);
      codeContainer.appendChild(panelsWrap);
      return codeContainer;
    },
    activateCodeTab(tabBtn) {
      const root = tabBtn.closest(".code-block-tabs");
      if (!root) return;
      const id = tabBtn.dataset.tab;
      root.querySelectorAll(".code-tab").forEach((b) => {
        const on = b === tabBtn;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      root.querySelectorAll(".code-tab-panel").forEach((p) => {
        p.classList.toggle("is-active", p.dataset.tab === id);
      });
    },
    switchCodeTabsInHeading(headingId, tabId) {
      if (!tabId) return;
      const heading = document.getElementById(headingId);
      if (!heading) return;
      const sectionNodes = this.getHeadingSectionNodes(heading);
      sectionNodes.forEach((node) => {
        if (!node.querySelectorAll) return;
        node.querySelectorAll(`.code-tab[data-tab="${tabId}"]`).forEach((btn) => {
          this.activateCodeTab(btn);
        });
      });
    },
    normalizeSearchMatchText(text) {
      return String(text || "")
        .replace(/\u00a0/g, " ")
        .replace(/\s+/g, " ")
        .replace(/\s*([,;:])\s*/g, "$1")
        .replace(/\s*([{}()\[\]])\s*/g, "$1")
        .trim()
        .toLowerCase();
    },
    compactSearchText(text) {
      return this.normalizeSearchMatchText(text).replace(/\s+/g, "");
    },
    searchHaystackMatchesKeyword(haystackNorm, keywordNorm) {
      if (!keywordNorm || !haystackNorm) return false;
      if (haystackNorm.includes(keywordNorm)) return true;
      const hk = this.compactSearchText(haystackNorm);
      const kk = this.compactSearchText(keywordNorm);
      return kk.length > 0 && hk.includes(kk);
    },
    inferCodeTabHintFromKeyword(keywordRaw) {
      const k = this.normalizeSearchMatchText(keywordRaw);
      if (!k) return null;
      if (/\bclass\s+\w+:/.test(k)) return "swift";
      if (/\b(func|var|let|extension|import)\b/.test(k) && !k.includes("#import"))
        return "swift";
      if (k.includes("#import") || k.includes("@interface") || k.includes("@implementation"))
        return "objective-c";
      return null;
    },
    /**
     * 目录树/段落搜索用：统一空白与常见全角标点，避免「App Key:」与正文「App Key：」互搜不到
     */
    normalizeForTocSearch(text) {
      return String(text || "")
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .replace(/\uFF1A/g, ":")
        .replace(/\uFF0C/g, ",")
        .replace(/\u3002/g, ".")
        .replace(/\uFF0E/g, ".")
        .replace(/\uFF08/g, "(")
        .replace(/\uFF09/g, ")")
        .replace(/[，、]/g, ",")
        .toLowerCase()
        .trim();
    },
    normalizeForTocSearchWithMap(text) {
      const source = String(text || "");
      const chars = [];
      const indexMap = [];
      let lastWasSpace = false;

      for (let i = 0; i < source.length; i++) {
        const raw = source[i];
        let normalized = raw.normalize("NFKC").replace(/[\u200B-\u200D\uFEFF]/g, "");
        if (!normalized) continue;

        normalized = normalized
          .replace(/\uFF1A/g, ":")
          .replace(/\uFF0C/g, ",")
          .replace(/\u3002/g, ".")
          .replace(/\uFF0E/g, ".")
          .replace(/\uFF08/g, "(")
          .replace(/\uFF09/g, ")")
          .replace(/[，、]/g, ",")
          .toLowerCase();

        for (const ch of normalized) {
          if (/\s/.test(ch)) {
            if (lastWasSpace || chars.length === 0) continue;
            chars.push(" ");
            indexMap.push(i);
            lastWasSpace = true;
          } else {
            chars.push(ch);
            indexMap.push(i);
            lastWasSpace = false;
          }
        }
      }

      while (chars.length && chars[chars.length - 1] === " ") {
        chars.pop();
        indexMap.pop();
      }

      return {
        text: chars.join(""),
        indexMap,
      };
    },
    getFlexiblePunctuationPattern(ch) {
      const map = {
        ":": "[\\uFF1A:]",
        ",": "[\\uFF0C,，、]",
        ".": "[\\u3002\\uFF0E.]",
        "(": "[\\uFF08(]",
        ")": "[\\uFF09)]",
        "?": "[\\uFF1F?]",
        "!": "[\\uFF01!]",
        ";": "[\\uFF1B;；]",
        "[": "[\\uFF3B\\[]",
        "]": "[\\uFF3D\\]]",
        "{": "[\\uFF5B\\{]",
        "}": "[\\uFF5D\\}]",
      };
      return map[ch] || "";
    },
    /**
     * 正文高亮：兼容中英文标点及其前后空白差异
     */
    buildFlexibleSearchPattern(keyword) {
      const t = String(keyword || "")
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim();
      if (!t) return "";
      return Array.from(t)
        .map((ch) => {
          if (/\s/.test(ch)) return "\\s*";
          const punctuationPattern = this.getFlexiblePunctuationPattern(ch);
          if (punctuationPattern) return `\\s*(?:${punctuationPattern})\\s*`;
          return this.escapeRegExp(ch);
        })
        .join("");
    },
    getHeadingSectionNodes(heading) {
      const nodes = [];
      if (!heading) return nodes;
      let next = heading.nextSibling;
      const level = parseInt(heading.tagName.substring(1), 10);
      while (next) {
        if (
          next.nodeType === 1 &&
          /^H[1-6]$/.test(next.tagName) &&
          parseInt(next.tagName.substring(1), 10) <= level
        ) {
          break;
        }
        nodes.push(next);
        next = next.nextSibling;
      }
      return nodes;
    },
    /** querySelectorAll 不包含自身；标题下紧邻的 div.code-block-tabs 必须单独算入 */
    collectTabBlocksFromSectionNode(node) {
      if (!node || node.nodeType !== 1) return [];
      const list = [];
      if (node.classList && node.classList.contains("code-block-tabs")) {
        list.push(node);
      }
      if (node.querySelectorAll) {
        list.push(...node.querySelectorAll(".code-block-tabs"));
      }
      return list;
    },
    findSearchTargetInHeading(headingId, keyword) {
      const normalizedKeyword = this.normalizeSearchMatchText(keyword);
      if (!normalizedKeyword) return null;

      const heading = document.getElementById(headingId);
      if (!heading) return null;

      const sectionNodes = this.getHeadingSectionNodes(heading);
      for (const node of sectionNodes) {
        const tabBlocks = this.collectTabBlocksFromSectionNode(node);
        for (const tabBlock of tabBlocks) {
          const objcNorm = tabBlock.dataset.searchObjectiveC || "";
          const swiftNorm = tabBlock.dataset.searchSwift || "";
          const objcMatched = this.searchHaystackMatchesKeyword(
            objcNorm,
            normalizedKeyword
          );
          const swiftMatched = this.searchHaystackMatchesKeyword(
            swiftNorm,
            normalizedKeyword
          );
          if (!objcMatched && !swiftMatched) continue;

          let tabId = null;
          if (swiftMatched && !objcMatched) {
            tabId = "swift";
          } else if (objcMatched && !swiftMatched) {
            tabId = "objective-c";
          } else {
            const hint = this.inferCodeTabHintFromKeyword(keyword);
            if (hint === "swift" && swiftMatched) tabId = "swift";
            else if (hint === "objective-c" && objcMatched)
              tabId = "objective-c";
            else if (swiftMatched) tabId = "swift";
            else tabId = "objective-c";
          }

          const tabButton = tabId
            ? tabBlock.querySelector(`.code-tab[data-tab="${tabId}"]`)
            : null;

          return {
            scrollElement: heading,
            tabButton,
            tabId,
          };
        }
      }

      return null;
    },
    normalizeIosLangHeadingText(s) {
      return (s || "").replace(/\u00a0/g, " ").trim();
    },
    matchesIosLangLabelText(t) {
      return /^(objective-c|swift|objc)$/i.test(
        this.normalizeIosLangHeadingText(t)
      );
    },
    isRedundantIosLangListItem(li) {
      if (!li || !li.tagName || !/^LI$/i.test(li.tagName)) return false;
      return this.matchesIosLangLabelText(li.textContent);
    },
    /** Markdown 中 `- Objective-C` 等会生成 ul/ol，合并 Tab 时整段或末项去掉 */
    stripRedundantIosLangListBlock(listEl) {
      if (!listEl || !listEl.tagName || !/^UL|OL$/i.test(listEl.tagName))
        return false;
      const lis = Array.from(listEl.children).filter(
        (c) => c.tagName && /^LI$/i.test(c.tagName)
      );
      if (!lis.length) return false;
      if (lis.length === 1 && this.isRedundantIosLangListItem(lis[0])) {
        listEl.remove();
        return true;
      }
      const last = lis[lis.length - 1];
      if (this.isRedundantIosLangListItem(last)) {
        last.remove();
        const rest = Array.from(listEl.children).filter(
          (c) => c.tagName && /^LI$/i.test(c.tagName)
        );
        if (!rest.length) listEl.remove();
        return true;
      }
      return false;
    },
    isRedundantIosLangHeading(el) {
      if (!el || el.nodeType !== 1) return false;
      const tag = el.tagName.toLowerCase();
      if (tag === "li") return this.isRedundantIosLangListItem(el);
      if (/^h[1-6]$/.test(tag) || tag === "p") {
        return this.matchesIosLangLabelText(el.textContent);
      }
      return false;
    },
    tryStripRedundantSibling(el) {
      if (!el) return false;
      if (this.isRedundantIosLangHeading(el)) {
        el.remove();
        return true;
      }
      if (
        el.tagName &&
        /^P$/i.test(el.tagName) &&
        this.normalizeIosLangHeadingText(el.textContent) === ""
      ) {
        el.remove();
        return true;
      }
      if (el.tagName && /^UL|OL$/i.test(el.tagName)) {
        return this.stripRedundantIosLangListBlock(el);
      }
      return false;
    },
    removeRedundantLangHeadingsAroundTabPair(pre1, pre2) {
      if (!pre1 || !pre2) return;
      let before = pre1.previousElementSibling;
      while (before) {
        if (this.tryStripRedundantSibling(before)) {
          before = pre1.previousElementSibling;
          continue;
        }
        break;
      }
      if (pre1.parentNode === pre2.parentNode) {
        let n = pre1.nextElementSibling;
        while (n && n !== pre2) {
          const next = n.nextElementSibling;
          this.tryStripRedundantSibling(n);
          n = next;
        }
      } else {
        let mid = pre2.previousElementSibling;
        while (mid) {
          if (this.tryStripRedundantSibling(mid)) {
            mid = pre2.previousElementSibling;
            continue;
          }
          break;
        }
      }
      this.tryStripRedundantSibling(pre2.nextElementSibling);
    },
    onDocContentClick(e) {
      const tabBtn =
        e &&
        e.target &&
        e.target.closest &&
        e.target.closest(".code-tab");
      if (
        tabBtn &&
        this.$refs.docContent &&
        this.$refs.docContent.contains(tabBtn)
      ) {
        e.preventDefault();
        this.activateCodeTab(tabBtn);
        return;
      }
    },
    processCodeBlocks() {
      const contentElement = this.$refs.docContent;
      if (!contentElement || !hljs) return;

      const pres = Array.from(contentElement.querySelectorAll("pre")).filter(
        (pre) => pre.querySelector("code")
      );
      let i = 0;
      while (i < pres.length) {
        const pre1 = pres[i];
        const pre2 = pres[i + 1];
        const code1 = pre1.querySelector("code");
        const code2 = pre2 && pre2.querySelector("code");
        const lang1 = code1 ? this.getCodeLanguage(code1) : null;
        const lang2 = code2 ? this.getCodeLanguage(code2) : null;

        if (
          pre2 &&
          this.isSwiftObjcConsecutivePair(lang1, lang2) &&
          this.shouldMergeAsSwiftObjcTabs(code1, code2)
        ) {
          this.removeRedundantLangHeadingsAroundTabPair(pre1, pre2);
          const tabBlock = this.buildTabbedSwiftObjcBlock(
            pre1,
            pre2,
            lang1,
            lang2
          );
          pre1.parentNode.insertBefore(tabBlock, pre1);
          pre1.parentNode.removeChild(pre1);
          pre2.parentNode.removeChild(pre2);
          i += 2;
        } else {
          this.replacePreWithSingleCodeBlock(pre1);
          i += 1;
        }
      }
    },
    getCodeLanguage(codeElement) {
      const classList = codeElement.className.split(" ");
      for (const cls of classList) {
        if (cls.startsWith("language-")) {
          const raw = cls.replace("language-", "");
          const normalized = this.normalizeHljsLanguageId(raw);
          if (normalized && hljs.getLanguage(normalized)) return normalized;
          if (hljs.getLanguage(raw)) return raw;
          return normalized || raw;
        }
      }
      return null;
    },
    //复制代码到剪贴板
    copyToClipboard(text, button) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        const originalText = button.innerHTML;
        button.innerHTML = this.pageLanguage === "zh" 
          ? '<i class="fas fa-check"></i> 已复制' 
          : '<i class="fas fa-check"></i> Copied';
        button.classList.add("copied");

        setTimeout(() => {
          button.innerHTML = originalText;
          button.classList.remove("copied");
        }, 2000);
      } catch (fallbackErr) {
        alert(this.pageLanguage === "zh" ? "复制失败，请手动选择文本复制" : "Copy failed, please select text manually");
      } finally {
        document.body.removeChild(textArea);
      }
    },
    //处理标题，生成目录数据
   processHeadings() {
      const contentElement = this.$refs.docContent;
      if (!contentElement) return;
      
      // 强制递归找所有标题（保留原有逻辑）
      const headings = [];
      const findAllHeadings = (node) => {
        if (!node) return;
        if (node.nodeType === 1 && /^H[1-6]$/i.test(node.tagName)) {
          headings.push(node); // 👉 所有级别标题都收集，不过滤
        }
        if (node.childNodes && node.childNodes.length > 0) {
          Array.from(node.childNodes).forEach(child => findAllHeadings(child));
        }
      };
      findAllHeadings(contentElement);

      this.currentTocItems = [];
      this.structure = [];
      this.tocTree = [];
      let stack = [];

      headings.forEach((heading, index) => {
        const id = `heading${index}`;
        heading.id = id;
        heading.classList.add("section");
        const level = parseInt(heading.tagName.substring(1), 10);

        // 👉 1. currentTocItems保留所有级别（右侧导航只控制显示，不删数据）
        this.currentTocItems.push({
          id,
          text: heading.textContent.trim() || `未命名标题 ${level}级`,
          level, // 保留原始level，不修改
        });

        // 👉 2. tocTree构建：所有级别都加入，不过滤level≥4的节点
        const text = heading.textContent.trim() || `未命名标题 ${level}级`;
        const node = {
          id,
          text,
          level, // 保留4级+级别
          children: [],
          content: this.getHeadingContent(heading) // 4级标题的内容也会被提取
        };

        // 栈式构建逻辑不变（所有级别都参与层级构建）
        while (stack.length > 0 && stack[stack.length - 1].level >= level) {
          stack.pop();
        }
        if (stack.length === 0) {
          this.tocTree.push(node);
        } else {
          stack[stack.length - 1].children.push(node);
        }
        stack.push(node);

        // 原有结构树逻辑（右侧导航显示用）不变
        const tagName = heading.tagName.toLowerCase();
        if (tagName === "h1" || tagName === "h2") {
          const current = {
            id: heading.id,
            title: heading.textContent.trim(),
            children: [],
            node: heading,
          };
          this.structure.push(current);
        } else if (this.structure.length > 0 && ["h3", "h4", "h5"].includes(tagName)) {
          this.structure[this.structure.length - 1].children.push({
            id: heading.id,
            title: heading.textContent.trim(),
            level: tagName,
          });
        }
      });
      if (this.currentTocItems.length > 0) {
        this.activeTocId = this.currentTocItems[0].id;
      }
      this.$nextTick(() => this.enhanceHeadingAnchors());
    },
    buildHeadingPermalink(headingId) {
      const path = String(this.$route.fullPath || "").split("#")[0];
      const prefix = `${window.location.origin}${window.location.pathname}${window.location.search}`;
      const sep = path.includes("?") ? "&" : "?";
      return `${prefix}#${path}${sep}h=${encodeURIComponent(String(headingId))}`;
    },
    showLinkCopyToast(isError) {
      if (this.linkCopyToastTimer) {
        clearTimeout(this.linkCopyToastTimer);
        this.linkCopyToastTimer = null;
      }
      this.linkCopyToastIsError = isError;
      this.linkCopyToastBody = isError
        ? this.pageLanguage === "zh"
          ? "复制失败，请从地址栏手动复制"
          : "Copy failed — copy from the address bar"
        : this.pageLanguage === "zh"
          ? "链接已保存到剪贴板，随时可以粘贴"
          : "Link saved to clipboard. Ready to paste";
      this.linkCopyToastVisible = true;
      this.linkCopyToastTimer = setTimeout(() => {
        this.linkCopyToastVisible = false;
        this.linkCopyToastTimer = null;
      }, 2500);
    },
    async copyHeadingPermalink(headingId) {
      const url = this.buildHeadingPermalink(headingId);
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const ta = document.createElement("textarea");
          ta.value = url;
          ta.setAttribute("readonly", "");
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        window.history.replaceState(
          null,
          "",
          `#${this.$route.fullPath.split("#")[0]}${this.$route.fullPath.split("#")[0].includes("?") ? "&" : "?"}h=${encodeURIComponent(String(headingId))}`
        );
        this.showLinkCopyToast(false);
      } catch (e) {
        this.showLinkCopyToast(true);
      }
    },
    /** 仅右侧目录中展示的标题（level<4，与 toc-link 的 v-show 一致）显示复制链接 */
    enhanceHeadingAnchors() {
      const root = this.$refs.docContent;
      if (!root) return;
      const sel = "h1.section, h2.section, h3.section";
      root.querySelectorAll(sel).forEach((heading) => {
        if (!heading.id || heading.querySelector(".doc-heading-anchor")) return;
        const level = parseInt(heading.tagName.substring(1), 10);
        if (level >= 4) return;
        const a = document.createElement("a");
        a.className = "doc-heading-anchor";
        a.href = this.buildHeadingPermalink(heading.id);
        a.setAttribute(
          "aria-label",
          this.pageLanguage === "zh" ? "复制标题链接" : "Copy link to this heading"
        );
        a.innerHTML =
          '<svg class="doc-heading-anchor-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M593.932929 431.204848c-5.094141-5.378586-10.511515-10.265859-15.928889-14.80404-5.779394-5.895758-13.394747-9.425455-22.044444-9.425454-17.454545 0-31.702626 15.153131-31.702626 33.82303 0 8.248889 2.715152 15.825455 7.473131 21.721212 2.19798 2.857374 4.913131 5.210505 7.796364 7.227475 3.051313 2.702222 5.934545 5.223434 8.649697 8.248889l2.534141 2.857373c32.879192 35.012525 23.065859 95.599192-9.826263 130.598788L400.355556 761.41899c-32.892121 34.999596-86.458182 34.999596-119.337374 0l-2.715152-2.857374c-32.879192-35.167677-32.879192-92.224646 0-127.405252L340.350707 565.010101c7.964444-6.723232 13.058586-17.170101 13.058586-28.780606 0-20.363636-15.437576-36.861414-34.585859-36.861414a32.284444 32.284444 0 0 0-19.316363 6.4v-0.18101l-0.685253 0.672323c-2.37899 1.848889-4.57697 4.033939-6.606869 6.568081L227.788283 577.292929c-60.677172 64.788687-60.677172 170.653737 0 235.287273l2.547071 2.857374c60.677172 64.620606 159.844848 64.620606 220.353939 0L591.049697 665.470707c60.496162-64.620606 65.590303-166.774949 5.081212-231.408485l-2.19798-2.857374z m202.382223-219.797979l-2.534142-2.857374c-60.690101-64.620606-159.844848-64.620606-220.366869 0L433.066667 358.503434c-60.677172 64.633535-63.909495 158.202828-3.387475 222.823435l2.534141 2.702222c2.715152 2.857374 5.598384 5.714747 8.481616 8.41697 2.029899 2.521212 4.56404 4.719192 7.279192 6.4 4.408889 2.689293 9.50303 4.20202 14.920404 4.20202 16.614141 0 30.008889-14.299798 30.008889-31.974142 0-5.042424-1.021414-9.761616-3.051313-13.963636-3.904646-9.425455-11.351919-15.308283-16.44606-20.699798l-2.547071-2.676364c-32.879192-35.180606-20.337778-86.173737 12.554343-121.354343l140.515556-149.953939c32.879192-35.180606 86.445253-35.180606 119.337374 0l2.54707 2.689293c32.879192 35.167677 32.879192 92.224646 0 127.392323l-61.866666 66.146262c-8.481616 6.736162-13.911919 17.338182-13.91192 29.284849 0 20.195556 15.256566 36.512323 34.249697 36.512323 6.606869 0 12.709495-2.029899 17.958788-5.378586 0 0 0 0.155152 0.18101 0.155152l1.008485-1.008485c2.883232-2.185051 5.598384-4.706263 7.796364-7.744647l65.267071-64.129292c60.328081-64.284444 60.328081-170.149495-0.18101-234.938182z"></path></svg>';
        a.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.copyHeadingPermalink(heading.id);
        });
        heading.insertBefore(a, heading.firstChild);
        if (!heading.querySelector(".doc-heading-body")) {
          const body = document.createElement("span");
          body.className = "doc-heading-body";
          while (heading.childNodes.length > 1) {
            body.appendChild(heading.childNodes[1]);
          }
          heading.appendChild(body);
        }
      });
    },
     //获取标题下的内容（用于搜索匹配，和原搜索逻辑一致）
    getHeadingContent(heading) {
        const content = [];
        let next = heading.nextSibling;
        const level = parseInt(heading.tagName.substring(1));

        const getSearchableText = (node) => {
          if (!node) return "";
          if (node.nodeType !== 1) return node.textContent || "";

          const clone = node.cloneNode(true);

          // 移除代码块行号（避免 47 + 48 被拼成 4748 进入搜索结果摘要）
          clone
            .querySelectorAll(
              [
                // 本项目自定义行号
                "td.line-numbers",
                ".line-numbers",
                // highlightjs-line-numbers / hljs-ln
                "td.hljs-ln-numbers",
                ".hljs-ln-numbers",
                ".hljs-ln-n",
                // 其他常见行号 class
                ".line-number",
                ".code-line-number",
              ].join(",")
            )
            .forEach((el) => el.remove());

          return clone.textContent || "";
        };

        while (next) {
          // 遇到同级或更高级别的标题则停止遍历
          if (
            next.nodeType === 1 &&
            /^H[1-6]$/.test(next.tagName) &&
            parseInt(next.tagName.substring(1)) <= level
          ) {
            break;
          }

          const text = getSearchableText(next).trim();
          if (text) content.push(text);

          next = next.nextSibling;
        }

        return content.join(" ");
      },
    // 初始化标题观察者（滚动监听高亮当前目录）
    initHeadingObserver() {
      const contentElement = this.$refs.docContent;
      const container = this.contentContainer;
      if (!contentElement || !container) return;

      if (this.headingObserver) {
        this.headingObserver.disconnect();
      }

      const headings = Array.from(contentElement.querySelectorAll("h1, h2, h3"));
      if (!headings.length) return;

      // 在方法内部定义 offset 变量
      const offset = 80;

      this.headingObserver = new IntersectionObserver(
        (entries) => {
          if (this.manualActiveId || this.isScrolling) return;

          const visibleHeadings = entries
            .filter(entry => entry.isIntersecting)
            .map(entry => entry.target)
            .sort((a, b) => a.offsetTop - b.offsetTop);

          let currentVisibleHeading = null;

          if (visibleHeadings.length > 0) {
            currentVisibleHeading = visibleHeadings[0];
          } else {
            // 从 container 中实时计算 viewportTop
            const viewportTop = container.scrollTop;

            const closestHeading = headings.reduce((closest, h) => {
              const hTop = h.offsetTop;
              const closestTop = closest.offsetTop;
              return (hTop <= viewportTop + offset && hTop > closestTop) ? h : closest;
            }, headings[0]);
            currentVisibleHeading = closestHeading;
          }

          if (currentVisibleHeading && currentVisibleHeading.id !== this.activeTocId) {
            this.activeTocId = currentVisibleHeading.id;
          }
        },
        {
          root: container,
          rootMargin: "0px 0px -80% 0px",
          threshold: 0.1
        }
      );

      headings.forEach((heading) => this.headingObserver.observe(heading));

      if (!this.activeTocId) {
        this.activeTocId = headings[0].id;
      }
    },
    // 获取「最终要高亮的导航ID」（确保唯一高亮）
    getFinalHighlightId() {
  // 1. 手动点击优先（5秒内锁定）
  if (this.manualActiveId) {
    const manualItem = this.currentTocItems.find(item => item.id === this.manualActiveId);
    if (manualItem) return this.manualActiveId;
    this.manualActiveId = '';
  }

  // 2. 自动高亮/默认高亮（滚动/初始化）
  if (!this.activeTocId && this.currentTocItems.length > 0) {
    // 页面初始化：默认选中第一个导航
    this.activeTocId = this.currentTocItems[0].id;
  }

  if (!this.activeTocId) return null;
  
  const activeItem = this.currentTocItems.find(item => item.id === this.activeTocId);
  if (!activeItem) return null;

  if (activeItem.level < 4) {
    return activeItem.id;
  } else {
    const activeIndex = this.currentTocItems.findIndex(item => item.id === this.activeTocId);
    for (let i = activeIndex - 1; i >= 0; i--) {
          const parentItem = this.currentTocItems[i];
          if (parentItem.level < 4) {
            return parentItem.id;
          }
        }
      }
      return this.currentTocItems[0]?.id || null; // 兜底：选第一个
    },
    //滚动到指定标题
    scrollToHeading(id, scrollTargetElement = null) {
      const container = this.contentContainer;
      if (!container) return;

      const headingElement = document.getElementById(id);
      if (!headingElement) {
        this.manualActiveId = '';
        this.isScrolling = false;
        return;
      }
      const targetElement = scrollTargetElement || headingElement;

      // 点击锁定5秒，兼顾点击高亮和滚动切换
      this.manualActiveId = id;
      this.activeTocId = id;
      this.isScrolling = true;

      // 重置手动锁定计时器
      clearTimeout(this.manualClickLockTime);
      this.manualClickLockTime = setTimeout(() => {
        this.manualActiveId = '';
      }, 2000);

      // 滚动逻辑（兼容底部）
      const base = this.$route.fullPath.split("#")[0];
      const sep = base.includes("?") ? "&" : "?";
      window.history.replaceState(null, null, `#${base}${sep}h=${encodeURIComponent(String(id))}`);
      // 用 rect 计算“容器内”准确滚动距离，避免 offsetTop/offsetParent 差异导致偏移
      const containerRect = container.getBoundingClientRect();
      const targetRect = targetElement.getBoundingClientRect();
      const targetTop = container.scrollTop + (targetRect.top - containerRect.top) - 12;
      // 滚动时不超过最大高度（避免滚动到底部后触发兜底逻辑）
      const maxScrollTop = container.scrollHeight - container.clientHeight;
      const finalTop = Math.min(targetTop, maxScrollTop);

      container.scrollTo({
        top: finalTop,
        behavior: "smooth",
      });

      // 滚动结束标记
      clearTimeout(this.scrollReleaseTimer);
      this.scrollReleaseTimer = setTimeout(() => {
        this.isScrolling = false;
        // 滚动结束后强制触发一次监听，确保高亮正确
        this.syncActiveTocOnScroll();
      }, 800);
    },
    //初始化hash锚点定位（页面加载时执行）
    initHashAnchor() {
      const anchorId = this.getHeadingIdFromUrl();
      if (!anchorId) return;
      this.$nextTick(async () => {
        await this.waitForDocImages();
        requestAnimationFrame(() => {
          const targetElement = this.resolveHeadingElement(anchorId);
          if (targetElement && targetElement.id && this.contentContainer) {
            this.scrollToHeading(targetElement.id);
          }
        });
      });
    },

    //初始化窗口点击监听（点击空白处关闭菜单）
    initWindowClickListener() {
      window.addEventListener('click', this.handleWindowClick);
    },
    //处理窗口点击事件
    handleWindowClick() {
      // 关闭联系菜单
      this.isContactMenuShow = false;
    },
    //刷新页面
    refreshPage() {
      window.location.reload();
    },
    // 菜单点击
    menuChange(item) {
      if (item.id == this.activeMenuId) {
        return
      }
      this.docUrl = item.docUrl
      this.activeMenuId = item.id.toString();    
      this.$router.push({
        path: `/help/${this.pageLanguage}/${item.id}/`, // 拼接当前页面路径 + 菜单 id
        query: {},
      });
      this.getDocContent()
    },
    // 根据路由id匹配对应文档路径
    findDocUrlById(menuList, targetId) {
      if (!Array.isArray(menuList) || !targetId) return null;
      for (const parentItem of menuList) {
        const children = parentItem.children || [];
        // 遍历子菜单，查找匹配 ID
        for (const childItem of children) {
          if (childItem.id === targetId) {
            // 匹配成功，返回 docUrl
            return childItem.docUrl;
          }
        }
      }
    },
    // 切换语言
    switchLanguage(lang) {
      if (lang == this.pageLanguage) {
        return; // 相同则直接返回，不执行跳转
      }
      this.pageLanguage = lang
      this.$router.push({
        path: `/help/${this.pageLanguage}/${this.activeMenuId}/`, // 拼接当前页面路径 + 菜单 id
        query: {},
      });
      this.updateLangText()
      this.getDocContent()
    },
    // 请求文档滚动到顶部
    getDocContent() {
      const container = this.contentContainer;
      const slidCon = this.slidContainer;
      if (container) {
        container.scrollTo({ top: 0, behavior: "auto" });
      }
      if (slidCon) {
        slidCon.scrollTo({ top: 0, behavior: "auto" });
      }
      this.fetchDocContent();
    },
     // —————————— 搜索功能核心方法 ——————————
    handleSearchInput(value) {
      this.clearSearchHighlightRemovalTimer();
      this.searchKeyword = value
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => this.handleSearch(), this.searchDebounceTime);
    },
    clearSearchHighlightRemovalTimer() {
      if (this.searchHighlightClearTimer) {
        clearTimeout(this.searchHighlightClearTimer);
        this.searchHighlightClearTimer = null;
      }
    },
    scheduleSearchHighlightRemoval() {
      this.clearSearchHighlightRemovalTimer();
      this.searchHighlightClearTimer = setTimeout(() => {
        this.highlightKeywordInDoc("");
        this.currentResultIndex = -1;
        this.searchHighlightClearTimer = null;
      }, 5000);
    },
   // 核心搜索逻辑（优化版：空关键词时仅清除高亮，不重置HTML）
    handleSearch() {
      const keyword = this.searchKeyword.trim().toLowerCase();
      const contentEl = this.$refs.docContent;
      this.searchResults = [];
      this.currentResultIndex = -1;

      if (!keyword) {
        // 空关键词：仅清除高亮，不重置HTML（保留标题id）
        contentEl && this.highlightKeywordInDoc('');
        return;
      }
      // 有关键词：正常遍历目录树+执行高亮
      if (this.tocTree.length === 0 || !contentEl) return;
      // 兜底：热更新/异步渲染后，确保 tocTree.content 与当前 DOM 一致（避免旧摘要残留）
      this.refreshTocNodeContentsFromDom();
      this.searchResults = this.traverseTocTree(keyword);
      this.highlightKeywordInDoc(keyword);
      // this.searchResults.length > 0 && (this.currentResultIndex = 0);
    },
    refreshTocNodeContentsFromDom() {
      const contentEl = this.$refs.docContent;
      if (!contentEl || !this.tocTree || this.tocTree.length === 0) return;
      const headings = Array.from(contentEl.querySelectorAll("h1, h2, h3, h4, h5, h6"));
      const map = new Map();
      headings.forEach((h) => {
        if (h && h.id) map.set(h.id, h);
      });

      const walk = (node) => {
        const h = map.get(node.id);
        if (h) node.content = this.getHeadingContent(h);
        if (Array.isArray(node.children)) node.children.forEach(walk);
      };
      this.tocTree.forEach(walk);
    },
    // 遍历目录树匹配关键词（只保留叶子节点，去重）
    traverseTocTree(keyword) {
      const keyNorm = this.normalizeForTocSearch(keyword);
      if (!keyNorm) return [];

      // 1. 先收集所有匹配节点，并构建「节点ID → 完整节点信息」的映射
      const allMatches = [];
      const nodeMap = new Map(); // key: node.id, value: 完整节点对象
      const nodeChildMap = new Map(); // key: node.id, value: 所有子节点ID

      const traverse = (node, path = []) => {
        const currentPath = [...path, node.text];
        const fullPath = currentPath.join(' > ');

        // 构建子节点ID映射
        const childIds = [];
        const collectChildIds = (n) => {
          n.children.forEach(child => {
            childIds.push(child.id);
            collectChildIds(child);
          });
        };
        collectChildIds(node);
        nodeChildMap.set(node.id, childIds);

        // 检查是否匹配（归一化标点/空白，避免全角冒号等导致整句搜不到）
        const isMatch =
          this.normalizeForTocSearch(node.text).includes(keyNorm) ||
          this.normalizeForTocSearch(node.content || "").includes(keyNorm);

        if (isMatch) {
          const matchNode = {
            id: node.id,
            text: node.text,
            level: node.level,
            fullPath: fullPath, // 这里直接记录完整路径
            content: node.content || ''
          };
          allMatches.push(matchNode);
          nodeMap.set(node.id, matchNode);
        }

        // 递归子节点
        node.children.forEach(child => traverse(child, currentPath));
      };

      this.tocTree.forEach(node => traverse(node));

      // 2. 核心去重：如果节点的子节点有人匹配，就过滤掉当前节点
      const finalResults = [];
      allMatches.forEach(node => {
        const childIds = nodeChildMap.get(node.id) || [];
        const hasMatchedChild = allMatches.some(matchNode => childIds.includes(matchNode.id));

        if (!hasMatchedChild) {
          // 生成预览内容：用归一化串定位，但截取原文，保证列表高亮能命中真实文本
          const content = node.content || "";
          const normalizedContent = this.normalizeForTocSearchWithMap(content);
          const index = normalizedContent.text.indexOf(keyNorm);
          let previewContent = "";
          if (index === -1) {
            previewContent =
              content.substring(0, 200) + (content.length > 200 ? "..." : "");
          } else {
            const matchStart = normalizedContent.indexMap[index] || 0;
            const matchEndIndex = Math.min(
              normalizedContent.indexMap.length - 1,
              index + keyNorm.length - 1
            );
            const matchEnd =
              matchEndIndex >= 0
                ? (normalizedContent.indexMap[matchEndIndex] || 0) + 1
                : matchStart + 1;
            const start = Math.max(0, matchStart - 100);
            const end = Math.min(content.length, matchEnd + 100);
            previewContent =
              (start > 0 ? "..." : "") +
              content.substring(start, end) +
              (end < content.length ? "..." : "");
          }

          finalResults.push({
            id: node.id,
            text: node.text,
            fullPath: node.fullPath, // 这里直接用已经构建好的完整路径
            content: previewContent
          });
        }
      });

      // 3. ID去重（保险）
      const idSet = new Set();
      return finalResults.filter(item => {
        if (idSet.has(item.id)) return false;
        idSet.add(item.id);
        return true;
      });
    },
    // 文档内关键词高亮（跳过代码块；空关键词仅清除高亮）
    highlightKeywordInDoc(keyword) {
      const contentEl = this.$refs.docContent;
      if (!contentEl) return;

      contentEl.querySelectorAll(".search-highlight").forEach((span) => {
        const t = document.createTextNode(span.textContent);
        span.parentNode.replaceChild(t, span);
      });
      contentEl.normalize();

      const trimmed = (keyword || "").trim();
      if (!trimmed) return;

      const pattern = this.buildFlexibleSearchPattern(trimmed);
      if (!pattern) return;
      const textGroups = this.collectSearchableTextGroups(contentEl);
      textGroups.forEach(({ textNodes, fullText }) => {
        this.wrapSearchMatchesAcrossTextNodes(
          textNodes,
          fullText,
          new RegExp(pattern, "gi")
        );
      });
      this.highlightKeywordInCodeBlocks(new RegExp(pattern, "gi"));
    },
    isSearchHighlightBlockRoot(el) {
      if (!el || el.nodeType !== 1) return false;
      return /^(P|LI|TD|TH|BLOCKQUOTE|H1|H2|H3|H4|H5|H6|FIGCAPTION|SUMMARY)$/i.test(
        el.tagName
      );
    },
    getSearchHighlightRoot(el, boundary) {
      let current = el;
      let fallback = boundary;
      while (current && current !== boundary) {
        if (current.parentElement === boundary) fallback = current;
        if (this.isSearchHighlightBlockRoot(current)) return current;
        current = current.parentElement;
      }
      return fallback;
    },
    collectSearchableTextGroups(contentEl) {
      const groups = new Map();
      const walker = document.createTreeWalker(contentEl, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          const p = node.parentElement;
          if (!p) return NodeFilter.FILTER_REJECT;
          if (p.closest(".code-block, pre")) return NodeFilter.FILTER_REJECT;
          if (p.closest(".doc-heading-anchor")) return NodeFilter.FILTER_REJECT;
          if (p.classList && p.classList.contains("search-highlight")) {
            return NodeFilter.FILTER_REJECT;
          }
          if (/^SCRIPT|^STYLE|^NOSCRIPT$/i.test(p.tagName)) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      });

      let node;
      while ((node = walker.nextNode())) {
        const value = node.nodeValue || "";
        if (!value) continue;
        const root = this.getSearchHighlightRoot(node.parentElement, contentEl);
        if (!groups.has(root)) {
          groups.set(root, {
            textNodes: [],
            fullText: "",
          });
        }
        const group = groups.get(root);
        const start = group.fullText.length;
        group.fullText += value;
        group.textNodes.push({
          node,
          start,
          end: group.fullText.length,
        });
      }

      return Array.from(groups.values()).filter((group) => group.fullText);
    },
    highlightKeywordInCodeBlocks(reg) {
      const contentEl = this.$refs.docContent;
      if (!contentEl) return;
      const codeLines = Array.from(
        contentEl.querySelectorAll(".code-text code")
      );
      if (!codeLines.length) return;

      const textNodes = [];
      let fullText = "";

      codeLines.forEach((codeEl, lineIndex) => {
        const walker = document.createTreeWalker(
          codeEl,
          NodeFilter.SHOW_TEXT,
          null
        );
        let node;
        while ((node = walker.nextNode())) {
          const value = node.nodeValue || "";
          if (!value) continue;
          const start = fullText.length;
          fullText += value;
          textNodes.push({
            node,
            start,
            end: fullText.length,
          });
        }
        if (lineIndex < codeLines.length - 1) {
          fullText += "\n";
        }
      });

      if (!fullText) return;

      const nodeRanges = new Map();
      reg.lastIndex = 0;
      let match;
      while ((match = reg.exec(fullText)) !== null) {
        const trimmedRange = this.trimMatchRange(fullText, match.index, reg.lastIndex);
        const matchStart = trimmedRange.start;
        const matchEnd = trimmedRange.end;
        if (matchStart >= matchEnd) {
          if (match.index === reg.lastIndex) reg.lastIndex++;
          continue;
        }

        textNodes.forEach(({ node, start, end }) => {
          const overlapStart = Math.max(matchStart, start);
          const overlapEnd = Math.min(matchEnd, end);
          if (overlapStart >= overlapEnd) return;
          if (!nodeRanges.has(node)) nodeRanges.set(node, []);
          nodeRanges.get(node).push({
            start: overlapStart - start,
            end: overlapEnd - start,
          });
        });

        if (match.index === reg.lastIndex) reg.lastIndex++;
      }

      nodeRanges.forEach((ranges, node) => {
        ranges
          .sort((a, b) => b.start - a.start)
          .forEach(({ start, end }) => {
            this.wrapTextNodeRange(node, start, end);
          });
      });
    },
    wrapSearchMatchesAcrossTextNodes(textNodes, fullText, reg) {
      if (!textNodes.length || !fullText) return;
      const nodeRanges = new Map();
      reg.lastIndex = 0;
      let match;
      while ((match = reg.exec(fullText)) !== null) {
        const trimmedRange = this.trimMatchRange(fullText, match.index, reg.lastIndex);
        const matchStart = trimmedRange.start;
        const matchEnd = trimmedRange.end;
        if (matchStart >= matchEnd) {
          if (match.index === reg.lastIndex) reg.lastIndex++;
          continue;
        }

        textNodes.forEach(({ node, start, end }) => {
          const overlapStart = Math.max(matchStart, start);
          const overlapEnd = Math.min(matchEnd, end);
          if (overlapStart >= overlapEnd) return;
          if (!nodeRanges.has(node)) nodeRanges.set(node, []);
          nodeRanges.get(node).push({
            start: overlapStart - start,
            end: overlapEnd - start,
          });
        });

        if (match.index === reg.lastIndex) reg.lastIndex++;
      }

      nodeRanges.forEach((ranges, node) => {
        ranges
          .sort((a, b) => b.start - a.start)
          .forEach(({ start, end }) => {
            this.wrapTextNodeRange(node, start, end);
          });
      });
    },
    trimMatchRange(text, start, end) {
      let s = start;
      let e = end;
      while (s < e && /\s/.test(text[s])) s++;
      while (e > s && /\s/.test(text[e - 1])) e--;
      return { start: s, end: e };
    },
    wrapTextNodeRange(textNode, start, end) {
      const src = textNode && textNode.nodeValue;
      if (!src) return;
      if (start < 0 || end > src.length || start >= end) return;

      const matchedNode = textNode.splitText(start);
      const tailNode = matchedNode.splitText(end - start);
      const span = document.createElement("span");
      span.className = "search-highlight";
      span.textContent = matchedNode.nodeValue;
      matchedNode.parentNode.replaceChild(span, matchedNode);
      return tailNode;
    },
    // 转义正则特殊字符
    escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    // 搜索结果预览高亮
    highlightKeyword(content) {
      const keyword = this.searchKeyword.trim();
      if (!keyword || !content) return content;
      const pattern = this.buildFlexibleSearchPattern(keyword);
      if (!pattern) return content;
      const reg = new RegExp(pattern, "gi");
      return content.replace(
        reg,
        (m) => {
          const leading = (m.match(/^\s*/) || [""])[0];
          const trailing = (m.match(/\s*$/) || [""])[0];
          const core = m.slice(leading.length, m.length - trailing.length);
          if (!core) return m;
          return `${leading}<span class="search-highlight">${core}</span>${trailing}`;
        }
      );
    },
    // 滚动到指定搜索结果（确保跳转）
    scrollToResult(index) {
      if (index < 0 || index >= this.searchResults.length) return;
      this.currentResultIndex = index;
      const result = this.searchResults[index];
      const searchTarget = this.findSearchTargetInHeading(
        result.id,
        this.searchKeyword
      );
      if (searchTarget && searchTarget.tabId) {
        this.switchCodeTabsInHeading(result.id, searchTarget.tabId);
      }
      if (searchTarget && searchTarget.tabButton) {
        this.activateCodeTab(searchTarget.tabButton);
      }
      this.scrollToHeading(
        result.id,
        searchTarget ? searchTarget.scrollElement : null
      );
      this.scheduleSearchHighlightRemoval();
      setTimeout(()=>{
        this.showSearchPanel = false
        this.searchKeyword='';
        this.searchResults = []
      },100)
      
    },
    handleSearchClose(){
      this.clearSearchHighlightRemovalTimer();
      this.showSearchPanel = false;
      this.searchKeyword='';
      this.searchResults = []
    },
    // 监听内容滚动，自动识别当前在视图内的标题
    syncActiveTocOnScroll() {
      const container = this.contentContainer;
      if (!container || this.isScrolling) return;

      // 手动点击锁定期间跳过（5秒后释放）
      if (this.manualActiveId) return;

      const headings = Array.from(container.querySelectorAll('h1, h2, h3'));
      if (!headings.length) return;

      const viewportTop = container.scrollTop;
      const viewportHeight = container.clientHeight;
      const containerHeight = container.scrollHeight;
      const offset = 80; // 视口顶部偏移量，控制高亮触发时机
      const bottomThreshold = 50; // 底部阈值：剩余滚动<50px才判定为接近底部

      let currentId = null;

      // 核心：从前往后遍历，找到「第一个顶部超过视口+offset」的标题，选中它的上一个
      for (let i = 0; i < headings.length; i++) {
        const h = headings[i];
        const headingTop = h.offsetTop;
        const headingBottom = h.offsetTop + h.offsetHeight;
        
        // 计算标题距离容器底部的距离
        const headingToBottom = containerHeight - headingBottom;

        // 逻辑1：标题顶部超过视口 → 选中上一个（正常滚动的渐进式高亮）
        if (headingTop > viewportTop + offset) {
          currentId = i > 0 ? headings[i-1].id : headings[0].id;
          break;
        }

        // 逻辑2：遍历到最后一个标题，且接近底部 → 选中最后一个（仅最后一步才高亮）
        if (i === headings.length - 1) {
          const isNearBottom = (containerHeight - (viewportTop + viewportHeight)) < bottomThreshold;
          // 只有最后一个标题的底部进入视口，且接近底部时，才选中它
          if (headingBottom <= viewportTop + viewportHeight + bottomThreshold || isNearBottom) {
            currentId = h.id;
          } else {
            // 未到最后一步，仍选中当前可视的最后一个中间标题
            currentId = headings[i].id;
          }
        }
      }

      // 兜底：如果没找到，选第一个可视的标题
      if (!currentId) {
        const visibleHeading = headings.find(h => {
          const rect = h.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          return rect.top <= containerRect.bottom && rect.bottom >= containerRect.top;
        });
        currentId = visibleHeading ? visibleHeading.id : headings[0].id;
      }

      // 仅当ID变化时更新，避免频繁闪烁
      if (currentId && currentId !== this.activeTocId) {
        this.activeTocId = currentId;
      }
    },
  },
  watch: {
    "$route.params.menuId"() {
      this.syncDocFromRoute();
    },
    "$route.params.language"() {
      this.syncDocFromRoute();
    },
    "$route.query.h"() {
      this.initHashAnchor();
    },
},
};
</script>
<style>

/* 顶部导航栏 */
.header {
  position: fixed;
  top: 6px;
  left: 0;
  width: 100%;
  height: 60px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 100;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.logo-img {
  width: 8rem;
  height: 1.75rem;
}
.logo-line {
  width: 1px;
  height: 17px;
  background-color: #bfbfbf;
  margin: 5px 9px 4px 8px;
  display: inline-block;
  vertical-align: middle;
}
.logo-text {
  font-size: 1.125rem;
  line-height: 1.25rem;
  color: #262626;
}
.opt-box{
  display: flex;
}
.language-switcher {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
  
}
.switcher-options {
  display: flex;
  justify-content: center;
  align-items: center;
}

.option {
  color: #165dff;
  transition: all 0.2s ease;
}
.option.active {
  background-color: transparent;
  cursor: default;
  font-weight: bold;
}

.option .line{
  margin: 0 8px;
}
/* 搜索触发按钮 */
.search-trigger {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.5rem 0.8rem;
  border: 1px solid #bfbfbf;
  border-radius: 6px;
  cursor: pointer;
  color: #7f7f83 ;
  font-size: 0.875rem;
  transition: all 0.2s;
  margin-right: 20px;
  position: absolute;
  top: -15px;
  margin-left: 25px;
}
.search-trigger:hover {
  border-color: #0251ff;
  color: #0251ff;
  background: #f6faff;
}
.search-icon{
  width: 14px;
  height: 14px;
  margin-bottom: -2px;
}
.contact-btnBox {
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 0.875rem;
  line-height: 1.25rem;
  display: flex;
  align-items: center;
  border: 1px solid #333;
  padding: 7px 12px;
  border-radius: 6px;
  color: #262626;
}

.contact-btn {
  color: #262626;
  background-color: unset;
  margin-left: 0.5rem;
  border: none;
  cursor: pointer;
}

.contact-btnBox:hover {
  background: #f5f5f5;
}

.contact-dropdown {
  display: none;
  position: absolute;
  top: 127%;
  right: 0;
  left: auto;
  padding: 8px 16px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 50;
  min-width: 120px;
}

.contact-dropdown a {
  display: block;
  /* padding: 8px 12px; */
  font-size: 14px;
  color: #333;
  text-decoration: inherit;
}
.contact-dropdown a:hover {
  background-color: #f3f4f6;
}

.contact-dropdown.show {
  display: block;
}

.contact-icon {
  width: 14px;
  height: 14px;
}

.mail-icon {
  margin: 4px 8px 4px 0;
  width: 16px;
  height: 16px;
}
.contact-title {
  display: flex;
  align-items: center;
  margin: 0 0 4px;
}


.fade {
  opacity: 0;
}

/* 主体内容区：与左侧菜单同一行，避免 doc 掉到菜单下方 */
.content {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  padding: 1rem 3.5rem;
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
}
.doc-container {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  border-radius: 10px;
  padding: 20px 20px 50px;
  min-height: calc(100vh - 160px);
  color: #262626;
  font-size: 0.875rem;
}
/* 目录：固定宽度，不参与 flex 伸缩 */
.toc-sidebar {
  flex: 0 0 300px;
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  box-sizing: border-box;
  background-color: white;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.toc-list {
  list-style-type: none;
  flex: 1;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

.empty-state i {
  font-size: 3rem;
  margin-bottom: 15px;
  color: #dee2e6;
}

.empty-state h3 {
  margin-bottom: 10px;
  color: #6c757d;
}

.empty-state .empty-img {
  width: 250px;
  height: 250px;
  box-shadow: none;
  display: inline;
}

.empty-state .empty-text {
  text-align: center;
}

.empty-state .empty-btn {
  color: #fff;
  background-color: #333;
  width: 75px;
  height: 35px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.toc-item {
  margin-bottom: 5px;
}

.toc-link {
  display: block;
  padding: 8px 12px;
  text-decoration: none;
  color: #141414;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-size: 1rem;
  cursor: pointer;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.toc-link:hover {
  background-color: #f6f8fa;
  color: #0251ff;
}

.toc-link.active {
  background-color: #e6f2ff;
  color: #0251ff;
  font-weight: 400;
  border-left: 3px solid #0251ff;
}

.toc-level-1 {
  font-weight: 600;
  color: #24292e;
  margin-top: 10px;
}

.toc-level-2 {
  padding-left: 1.5rem;
  font-size: 0.8125rem;
}
.toc-level-3{
  padding-left: 3rem;
  font-size: 0.8125rem;
}
.toc-level-4{
  padding-left: 4.5rem;
  font-size: 0.8125rem;
}

.content-area {
  position: relative;
  height: 100%;
  flex: 1;
  min-width: 0;
  width: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
}

.content-wrapper {
  overflow-y: auto;
  width: 100%;
  padding: 0 1.5rem;
}
.content-wrapper_help {
  margin-top: 35px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  text-align: left;
}

h1 {
  font-size: 1.5rem;
  /* margin-top: 24px; */
  color: #141414;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eaecef;
}

h1:first-of-type {
  margin-top: 0;
}

h1:not(:first-of-type) {
  margin-top: 24px;
}

h2 {
  font-size: 1.25rem;
  margin: 1.5rem 0;
  color: #141414;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eaecef;
}

h3 {
  font-size: 1rem;
  margin: 1.5rem 0;
  color: #141414;
}

h4 {
  font-size: 0.875rem;
  margin: 20px 0 10px;
  color: #141414;
}

p {
  margin: 0.5rem 0;
  text-align: justify;
}

ul,
ol {
  margin-bottom: 16px;
  padding-left: 30px;
}

li {
  margin-bottom: 8px;
}

strong {
  color: #333;
  font-weight: bold;
}

.section {
  margin-bottom: 1.5rem;
  scroll-margin-top: 20px;
}

/* 仅 h1–h3 与右侧目录一致，带复制链接时的 flex 排版 */
h1.section,
h2.section,
h3.section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  column-gap: 0.5rem;
}

.doc-heading-anchor {
  flex: 0 0 22px;
  width: 22px;
  min-width: 22px;
  height: 22px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  line-height: 0;
  color: #595959;
  text-decoration: none;
  user-select: none;
  transition: color 0.15s ease;
}

.doc-heading-body {
  flex: 1;
  min-width: 0;
  text-align: left;
  line-height: 1.35;
}

.doc-heading-anchor-icon {
  display: block;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  transform: translateY(0.07em);
}

.doc-heading-anchor:hover,
.doc-heading-anchor:focus-visible {
  color: #0251ff;
  outline: none;
}

.link-copy-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  max-width: min(420px, calc(100vw - 32px));
  padding: 10px 18px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: rgba(20, 20, 20, 0.88);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
}

.link-copy-toast-fade-enter-active,
.link-copy-toast-fade-leave-active {
  transition: opacity 0.2s ease;
}

.link-copy-toast-fade-enter,
.link-copy-toast-fade-leave-to {
  opacity: 0;
}

/* 代码块样式 */
.code-block {
  margin: 0.5rem 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e1e4e8;
}

.code-header {
  background-color: #f6f8fa;
  padding: 12px 16px;
  border-bottom: 1px solid #e1e4e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: #586069;
}

.code-header--tabs {
  flex-wrap: wrap;
  gap: 8px 12px;
}

.code-tabs-bar {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  min-width: 0;
}

.code-tab {
  margin: 0;
  padding: 6px 12px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  font-size: 0.85rem;
  font-weight: 600;
  color: #586069;
  cursor: pointer;
  border-radius: 4px 4px 0 0;
}

.code-tab:hover {
  color: #0366d6;
  background: rgba(3, 102, 214, 0.06);
}

.code-tab.is-active {
  color: #0366d6;
  border-bottom-color: #0366d6;
}

.code-tab-panels {
  min-width: 0;
}

.code-tab-panel {
  display: none;
}

.code-tab-panel.is-active {
  display: block;
}

.code-language {
  font-weight: 600;
  color: #2c3e50;
}

.copy-btn {
  background: none;
  border: 1px solid #d1d5da;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.75rem;
  color: #586069;
  cursor: pointer;
  transition: all 0.2s;
}

.copy-btn:hover {
  background-color: #f3f4f6;
  border-color: #959da5;
}

.copy-btn.copied {
  background-color: #dafbe1;
  border-color: #2da44e;
  color: #2da44e;
}

.code-content {
  background-color: #fafbfc;
  margin: 0;
  padding: 0;
  overflow-x: auto;
}

.code-table {
  width: 100%;
  border-collapse: collapse;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  overflow-x: auto;
}

.code-table td {
  padding: 0;
  vertical-align: top;
  border: none;
}

.line-numbers {
  background-color: #f6f8fa;
  border-right: 1px solid #e1e4e8;
  color: #6a737d;
  padding: 16px 8px 16px 16px;
  text-align: center;
  user-select: none;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.9rem;
  line-height: 1.45;
  white-space: pre;
  min-width: 50px;
}

.code-text {
  padding: 16px;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.9rem;
  line-height: 1.25rem;
  white-space: pre;
  overflow-x: auto;
}

.code-text code {
  font-style: normal;
  background: none;
  padding: 0;
  border: none;
  font-family: inherit;
  font-size: 0.75rem;
  color: inherit;
}

/* 内联代码样式 */
p code,
li code {
  background-color: #f6f8fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.85em;
  color: #e74c3c;
  border: 1px solid #e1e4e8;
}

/* 表格样式 */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
  overflow: hidden;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

th {
  background-color: #f6f8fa;
  font-weight: 600;
  color: #595959 !important;
}
th strong {
  color: #595959 !important;
}

tr:hover {
  background-color: #f8f9fa;
}

/* 图片样式 */
.content-wrapper img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
  display: block;
}

.image-caption {
  text-align: center;
  font-style: italic;
  color: #6c757d;
  margin-top: -15px;
  margin-bottom: 20px;
  font-size: 0.9rem;
}
.search-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 1000;
}
.search-panel {
  position: fixed;
  top: 64px;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 90%;
  max-width: 1000px;
  max-height: 80vh;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.search-panel-header {
  padding: 1rem 1.2rem;
  border-bottom: 1px solid #e5e7eb;
}
.search-input-wrapper { position: relative; }
.search-input {
  width: 100%;
  padding: 0.8rem 2.5rem 0.8rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
}
.search-input:focus {
  border-color: #0251ff;
  box-shadow: 0 0 0 2px rgba(2,81,255,0.1);
}
.search-close {
  position: absolute;
  right: 0.8rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: #999;
  cursor: pointer;
  background: #fff;
  border: none;
}
.search-results {
  flex: 1;
  overflow-y: auto;
  padding: 0.8rem 1.2rem;
}
.search-result-item {
  padding: 0.8rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 0.5rem;
  border-left: 3px solid transparent;
}
.search-result-item:hover { background: #e6f2ff;
  border-left-color: #0251ff;}
.search-result-item.active {
  background: #e6f2ff;
  border-left-color: #0251ff;
}
.result-path {
  font-size: 0.9rem;
  /* color: #0251ff; */
  font-weight: 500;
  margin-bottom: 0.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.result-content {
  font-size: 0.875rem;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.no-results {
  padding: 3rem 0;
  text-align: center;
  color: #999;
  font-size: 0.9rem;
}
.search-panel-footer {
  padding: 0.8rem 1.2rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  color: #666;
}
.result-nav { display: flex; align-items: center; gap: 0.8rem; }
.result-nav button {
  width: 30px;
  height: 30px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.result-nav button:hover:not(:disabled) {
  border-color: #0251ff;
  color: #0251ff;
}
.result-nav button:disabled { opacity: 0.5; cursor: not-allowed; }
/* 关键词高亮 */
 .search-highlight {
  background: #fff2cc;
  color: #d9534f;
  font-weight: 500;
  padding: 0 2px;
  border-radius: 2px;
}
.code-text .search-highlight,
.result-content .search-highlight {
  color: #d9534f;
  font-weight: inherit;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}

@keyframes fade {
  0%,
  39%,
  100% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
}

::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-thumb {
  background: #f0f0f0;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
  .doc-container {
    flex-direction: column;
  }

  .content-area,
  .content-wrapper {
    width: 100%;
  }

  .toc-sidebar {
    width: 100%;
    height: 200px;
    border-right: none;
    border-bottom: 1px solid #e1e4e8;
  }
}
html {
  font-size: 16px;
}

@media (min-width: 1200px) and (max-width: 1919px) {
  html {
    font-size: 16px;
  }
}
@media (min-width: 1920px) {
  html {
    font-size: 16px;
  }
  .content {
    padding: 1rem 3.5rem;
  }
}
@media (min-width: 1440px) and (max-width: 1920px) {
  .content {
    padding: 1rem 3.5rem;
  }
  .content-wrapper {
    width: 100%;
  }
}
@media (min-width: 1280px) and (max-width: 1440px) {
  .content {
    padding: 1rem 2.5rem;
  }
  .content-wrapper {
    width: 100%;
  }
}
@media (max-width: 1280px) {
  .content {
    padding: 1rem;
  }
  .content-wrapper {
    width: 100%;
  }
}
</style>